import { ROUTE_MAP } from './url';

export const APARTMENT_ADAPTER = {
  studio: {
    label: '1BR Apartment',
    abbreviation: '1BR',
    bed: 1,
    wc: 1,
    scene: '68fafb7ae62230d4b4453d49',
    mini: '/assets/images/floorImg/studio.webp',
    url: 'studio',
  },
  '1pn': {
    label: '1BR Apartment',
    abbreviation: '1BR',
    bed: 1,
    wc: 1,
    scene: '68fadb0abeb5aead0ada1c6b',
    mini: '/assets/images/floorImg/1pn.webp',
    url: '1bedroom',
  },
  '1pn-plus': {
    label: '1BR+ Apartment',
    abbreviation: '1BR+',
    bed: 1,
    wc: 1,
    scene: '68fadb0abeb5aead0ada1c6b',
    mini: '/assets/images/floorImg/1pn-plus.webp',
    url: '1bedroom-plus',
  },
  '2pn-1wc': {
    label: '2BR-1WC Apartment',
    abbreviation: '2BR-1WC',
    bed: 2,
    wc: 1,
    scene: '68fafb04e62230d4b4453c85',
    mini: '/assets/images/floorImg/2pn-1wc.webp',
    url: '2bedroom-1wc',
  },
  '2pn-2wc': {
    label: '2BR-2WC Apartment',
    abbreviation: '2BR-2WC',
    bed: 2,
    wc: 2,
    scene: '68fafb04e62230d4b4453c85',
    mini: '/assets/images/floorImg/2pn-2wc.webp',
    url: '2bedroom-2wc',
  },
  '3pn': {
    label: '3BR Apartment',
    abbreviation: '3BR',
    bed: 3,
    wc: 2,
    scene: '68faffe9e62230d4b44540ff',
    mini: '/assets/images/floorImg/3pn.webp',
    url: '3bedroom',
  },
  '3pn-dualkey': {
    label: '3BR-Dualkey Apartment',
    abbreviation: '3BR-Dual Key',
    bed: 3,
    wc: 2,
    scene: '68faffe9e62230d4b44540ff',
    mini: '/assets/images/floorImg/3pn-dualkey.webp',
    url: '3bedroom-dualkey',
  },
};

export const AMENITY_ADAPTER = {
  shophouse: {
    label: 'Shophouse',
    scene: '68fb00b9e62230d4b445417f',
    url: 'shophouse',
  },
  pool: { label: 'Swimming Pool', scene: '68fb00d0e62230d4b44541ac', url: 'pool' },
  playground: {
    label: 'Sports Court',
    scene: '68fb00c3e62230d4b4454193',
    url: 'playground',
  },
};

export const AMENITIES_MAP = {
  '6903592c085ec50c650870ca': {
    label: 'Win-Mec',
    short: 'Win-Mec',
    url: `/${ROUTE_MAP.amenities.id}/win-mec`,
  },
  '68fb02e7e62230d4b445441b': {
    label: 'Win-Mark',
    short: 'Win-Mark',
    url: `/${ROUTE_MAP.amenities.id}/win-mark`,
  },
  '68fb00d0e62230d4b44541ac': {
    label: 'Swimming Pool',
    short: 'Swimming Pool',
    url: `/${ROUTE_MAP.amenities.id}/swimming-pool`,
  },
  '68fb00b9e62230d4b445417f': {
    label: 'Shophouse',
    short: 'Shophouse',
    url: `/${ROUTE_MAP.amenities.id}/shophouse`,
  },
  '68fb02f3e62230d4b445443c': {
    label: 'Win-Edu',
    short: 'Win-Edu',
    url: `/${ROUTE_MAP.amenities.id}/win-edu`,
  },
  '68fb0303e62230d4b4454459': {
    label: 'Kindergarten',
    short: 'Kindergarten',
    url: `/${ROUTE_MAP.amenities.id}/kindergarten`,
  },
  '68fb00c3e62230d4b4454193': {
    label: 'Sports Court',
    short: 'Sports Court',
    url: `/${ROUTE_MAP.amenities.id}/sports-court`,
  },
  '691d8f809d4e2e854cdb4192': {
    label: 'Reception Lobby',
    short: 'Reception Lobby',
    url: `/${ROUTE_MAP.amenities.id}/reception-lobby`,
  },
  '695398d76d44644c6c58a2bb': {
    label: 'Gate',
    short: 'Gate',
    url: `/${ROUTE_MAP.amenities.id}/gate`,
  },
  '695491fc6d44644c6c5909b6': {
    label: 'Gym',
    short: 'Gym',
    url: `/${ROUTE_MAP.amenities.id}/gym`,
  },
};

export const APARTMENT_MAP = {
  // Studio
  '68fafb7ae62230d4b4453d49': {
    label: '1BR Apartment',
    short: '1pn',
    url: `/${ROUTE_MAP.interior.id}/1br/overview`,
  },
  '68fa5dce3294b0149d46bb1f': {
    label: '1BR Apartment - Living Room',
    short: '1BR - Living Room',
    url: `/${ROUTE_MAP.interior.id}/1br/living-room`,
  },
  '68fa5dd33294b0149d46bb2a': {
    label: '1BR Apartment - Bedroom',
    short: '1BR - Bedroom',
    url: `/${ROUTE_MAP.interior.id}/1br/bedroom`,
  },
  '68fafb6de62230d4b4453d30': {
    label: '1BR Apartment - Bathroom',
    short: '1BR - Bathroom',
    url: `/${ROUTE_MAP.interior.id}/1br/bathroom`,
  },

  // 1PN Plus
  '68fadb0abeb5aead0ada1c6b': {
    label: '1BR Plus Apartment',
    short: '1BR+',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/overview`,
  },
  '68fadb07beb5aead0ada1c60': {
    label: '1BR+ Apartment - Bathroom',
    short: '1BR+ - Bathroom',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/bathroom`,
  },
  '68fadb13beb5aead0ada1c97': {
    label: '1BR+ Apartment - Secondary Bedroom',
    short: '1BR+ - Secondary Bedroom',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/secondary-bedroom`,
  },
  '68fadb11beb5aead0ada1c8c': {
    label: '1BR+ Apartment - Master Bedroom',
    short: '1BR+ - Master Bedroom',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/master-bedroom`,
  },
  '68fadb0ebeb5aead0ada1c81': {
    label: '1BR+ Apartment - Living Room',
    short: '1BR+ - Living Room',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/living-room`,
  },
  '68fadb0cbeb5aead0ada1c76': {
    label: '1BR+ Apartment - Balcony',
    short: '1BR+ - Balcony',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/balcony`,
  },

  // 2PN
  '68fafb04e62230d4b4453c85': {
    label: '2BR Apartment',
    short: '2BR',
    url: `/${ROUTE_MAP.interior.id}/2br/overview`,
  },
  '68fadb1bbeb5aead0ada1cb8': {
    label: '2BR Apartment - Living Room',
    short: '2BR - Living Room',
    url: `/${ROUTE_MAP.interior.id}/2br/living-room`,
  },
  '68fafac4e62230d4b4453bc0': {
    label: '2BR Apartment - Balcony',
    short: '2BR - Balcony',
    url: `/${ROUTE_MAP.interior.id}/2br/balcony`,
  },
  '68fafa0ee62230d4b4453afb': {
    label: '2BR Apartment - Bedroom 1',
    short: '2BR - Bedroom 1',
    url: `/${ROUTE_MAP.interior.id}/2br/bedroom-1`,
  },
  '68fafaade62230d4b4453b94': {
    label: '2BR Apartment - Bedroom 2',
    short: '2BR - Bedroom 2',
    url: `/${ROUTE_MAP.interior.id}/2br/bedroom-2`,
  },
  '68fafa3fe62230d4b4453b4b': {
    label: '2BR Apartment - Corridor',
    short: '2BR - Corridor',
    url: `/${ROUTE_MAP.interior.id}/2br/corridor`,
  },
  '68fafa1fe62230d4b4453b2c': {
    label: '2BR Apartment - Bathroom',
    short: '2BR - Bathroom',
    url: `/${ROUTE_MAP.interior.id}/2br/bathroom`,
  },

  // 3PN
  '68faffe9e62230d4b44540ff': {
    label: '3BR Apartment',
    short: '3BR',
    url: `/${ROUTE_MAP.interior.id}/3br/overview`,
  },
  '68fafc43e62230d4b4453e08': {
    label: '3BR Apartment - Kitchen',
    short: '3BR - Kitchen',
    url: `/${ROUTE_MAP.interior.id}/3br/kitchen`,
  },
  '68fafffae62230d4b4454114': {
    label: '3BR Apartment - Living Room',
    short: '3BR - Living Room',
    url: `/${ROUTE_MAP.interior.id}/3br/living-room`,
  },
  '68fafd8be62230d4b4453f60': {
    label: '3BR Apartment - Bathroom 1',
    short: '3BR - Bathroom 1',
    url: `/${ROUTE_MAP.interior.id}/3br/bathroom-1`,
  },
  '68fafc59e62230d4b4453e29': {
    label: '3BR Apartment - Bedroom 1',
    short: '3BR - Bedroom 1',
    url: `/${ROUTE_MAP.interior.id}/3br/bedroom-1`,
  },
  '68fafd9be62230d4b4453f75': {
    label: '3BR Apartment - Bathroom 2',
    short: '3BR - Bathroom 2',
    url: `/${ROUTE_MAP.interior.id}/3br/bathroom-2`,
  },
  '68fafdaee62230d4b4453f99': {
    label: '3BR Apartment - Bedroom 3',
    short: '3BR - Bedroom 3',
    url: `/${ROUTE_MAP.interior.id}/3br/bedroom-3`,
  },
  '68fafc29e62230d4b4453dee': {
    label: '3BR Apartment - Balcony',
    short: '3BR - Balcony',
    url: `/${ROUTE_MAP.interior.id}/3br/balcony`,
  },
  '69129061306dc464b887ed69': {
    label: '3BR Apartment - Bedroom 2',
    short: '3BR - Bedroom 2',
    url: `/${ROUTE_MAP.interior.id}/3br/bedroom-2`,
  },
};

export const SCENES_MAP = {
  '68e768a4fa4f187e528e21c2': {
    label: 'The Win City Overview',
    short: 'Overview',
    url: `/${ROUTE_MAP.overview.id}`,
  },
  '68f9d3773294b0149d4685ba': {
    label: 'The Tower',
    short: 'The Tower',
    url: `/${ROUTE_MAP.overview.id}/the-tower`,
  },
  ...AMENITIES_MAP,
  ...APARTMENT_MAP,
};

const slugify = (text) =>
  String(text || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Safety net: every scene in the tour data must be routable. Scenes that have no
// explicit entry above (e.g. added to the tour later) get one derived from their
// group and title, so selecting them never ends in a "Scene is missing" error.
export const registerMissingScenes = (scenes = []) => {
  const usedUrls = new Set(Object.values(SCENES_MAP).map(({ url }) => url));
  scenes.forEach((scene) => {
    const sceneId = scene && scene._id;
    if (!sceneId || SCENES_MAP[sceneId]) return;

    const isAmenity = scene.groupId === 'amenities';
    const section = isAmenity ? ROUTE_MAP.amenities.id : ROUTE_MAP.overview.id;
    const slug = slugify(scene.title) || sceneId;
    let url = `/${section}/${slug}`;
    if (usedUrls.has(url)) url = `${url}-${sceneId.slice(-4)}`;
    usedUrls.add(url);

    const entry = {
      label: scene.title || slug,
      short: scene.title || slug,
      url,
    };
    SCENES_MAP[sceneId] = entry;
    if (isAmenity) AMENITIES_MAP[sceneId] = entry;
  });
};
